<div class="has-feedback" style="margin-bottom: 0; overflow: hidden">
    <input
        type="text"
        [(ngModel)]="companyFilter"
        placeholder="Choose Company"
        class="form-control"
        container="body"
        [wsTypeahead]="companies$"
        (blur)="onBlur()"
        typeaheadOptionField="companyName"
        (typeaheadLoading)="typeaheadLoading($event)"
        (typeaheadNoResults)="onNoResults($event)"
        (typeaheadOnSelect)="companySelected($event)"
        [typeaheadMinLength]="2"
        [typeaheadScrollable]="true"
        [typeaheadWaitMs]="500"
        [typeaheadOptionsLimit]="1000"
        (change)="checkForBlank()"
    />
    @if (loadingCompanies) {
        <i class="fa fa-spinner fa-pulse form-control-feedback"></i>
    }
</div>
